var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.39106 7.47603C5.63514 7.23195 6.03087 7.23195 6.27495 7.47603L9.99967 11.2007L13.7244 7.47603C13.9685 7.23195 14.3642 7.23195 14.6083 7.47603C14.8523 7.7201 14.8523 8.11583 14.6083 8.35988L10.4416 12.5265C10.3244 12.6438 10.1654 12.7096 9.99967 12.7096C9.83392 12.7096 9.67492 12.6438 9.55776 12.5265L5.39106 8.35988C5.14699 8.11583 5.14699 7.7201 5.39106 7.47603Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpDownArrow);
export default __webpack_public_path__ + "static/media/up_down_arrow.355be2f6e09fa61cd7ec7fb4af50f86d.svg";
export { ForwardRef as ReactComponent };